// extracted by mini-css-extract-plugin
export default {"headerTitle":"HeaderTitle_headerTitle__v6src"};